import { Skeleton, Stack } from '@chakra-ui/react'

export const LoadingState = () => (
  <Stack mt={6} spacing={4}>
    <Skeleton height="48px" borderRadius="md" />
    <Skeleton height="48px" borderRadius="md" />
  </Stack>
)
